
export const SEZIONI_GUIDA = [
  {
    title: "LISTA DI CONTROLLO ALL'ARRIVO",
    text: "Procedure da eseguire nel corso delle prime settimane dall'arrivo a Milano",
  },
  {
    title: 'BENVENUTI IN ITALIA',
    text: 'Nozioni essenziali sulla nostra cità, sulla Regione e sullo Stato',
  },
  {
    title: 'PERMESSI E AUTORIZZAZIONI',
    text: "Richiedere permesso di soggiorno, codice fiscale, iscrizione anagrafica e Carta d'Identità",
  },
  {
    title: 'ISTRUZIONE',
    text: 'Il sistema scolastico italiano e le procedure di iscrizione',
  },
  {
    title: 'LAVORO',
    text: 'Trovare lavoro e lavorare a Milano',
  },
  {
    title: 'LINGUA ITALIANA',
    text: 'Accedere ai corsi di italiano presenti sul territorio',
  },
  {
    title: 'ASSISTENZA MEDICA E SANITARIA',
    text: 'Accedere al servizio sanitario, inclusi i servizi per la salute mentale',
  },
  {
    title: 'SERVIZI SOCIALI',
    text: 'Servizi di supporto socio-finanziario accessibili a categorie specifiche o in circostanze particolari',
  },
  {
    title: 'TRASPORTI',
    text: "Muoversi all'interno della città",
  },
  {
    title: 'NORME IN MATERIA DI ALLOGGI E CONTI BANCARI',
    text: "Trovare un appartamento, richiedere l'allacciamento delle utenze, aprire un conto bancario e gettare i rifiuti",
  },
  {
    title: 'ATTIVITÀ RICREATIVE E CULTURALI',
    text: 'Luoghi di aggregazione e istituzioni culturali presenti a Milano',
  },
  {
    title: 'INFORMAZIONI IMPORTANTI',
    text: 'Calendario delle festività, lista di numeri utili e altri strumenti',
  },
];
